import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id D45D7513-AA4C-43CA-8435-CA6AD2B7F868
 * name table-column
 * version: 2.1.19
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/table-column.svg
 * tags
 * - Text / Content / Format 
 */
export const TableColumnIcon = createSvgIcon(<><path d="M8,2H16A2,2 0 0,1 18,4V20A2,2 0 0,1 16,22H8A2,2 0 0,1 6,20V4A2,2 0 0,1 8,2M8,10V14H16V10H8M8,16V20H16V16H8M8,4V8H16V4H8Z" /></>, 'TableColumnIcon');
export default TableColumnIcon